var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "url(#paint0_linear_552_14)",
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1503 101.249H54.1002C55.0108 101.249 55.75 101.988 55.75 102.899V107.849C55.75 108.759 55.0108 109.499 54.1002 109.499H49.1503C48.2396 109.499 47.5 108.759 47.5 107.849V102.899C47.5 101.988 48.2396 101.249 49.1503 101.249Z",
    fill: "#FF414D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 20.3998C55.75 19.4891 55.0108 18.75 54.1002 18.75H49.1503C48.2396 18.75 47.5 19.4891 47.5 20.3998V91.349C47.5 92.2597 48.2396 92.9988 49.1503 92.9988H54.1002C55.0108 92.9988 55.75 92.2597 55.75 91.349",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.75 59.9993C55.75 55.4868 62.6587 55.8743 63.9999 55.8743C65.3412 55.8743 72.2499 56.0145 72.2499 59.9993C72.2499 62.6558 72.2499 78.6057 72.2499 107.849C72.2499 108.759 72.9891 109.499 73.8997 109.499H78.8496C79.7603 109.499 80.4999 108.759 80.4999 107.849C80.4999 74.5801 80.4999 56.5935 80.4999 53.8892C80.4999 49.8327 67.9793 47.6243 63.9999 47.6243C55.75 47.6134 51.625 48.9884 51.625 51.7493",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_552_14",
    x1: 0,
    y1: 0,
    x2: 128,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0195A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000057"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/AppIcon.98d7f0c811b025cd2bdd7c627c861233.svg";
export { ForwardRef as ReactComponent };